import React from "react";
import SEO from "../components/SEO";
import howItWorksData from "../data/howItWorks.json";
import { logActivity } from "../utils/activity";

export default function HowItWorks() {
  return (
    <div className="bg-slate-50">
      <SEO
        title={howItWorksData.seo?.title}
        description={howItWorksData.seo?.description}
        ogType="website"
        ogImage={howItWorksData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {howItWorksData.eyebrow}
        </p>
        <h1 className="page-title mt-3">{howItWorksData.title}</h1>
        <p className="mt-4 text-lg text-slate-600">
          {howItWorksData.subtitle}
        </p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-6 md:grid-cols-3">
          {/* <!-- Replace with dynamic content from JSON --> */}
          {howItWorksData.steps.map((step) => (
            <div key={step.title} className="card p-6">
              <div className="text-2xl">{step.icon}</div>
              <h2 className="mt-4 text-lg font-semibold text-slate-900">
                {step.title}
              </h2>
              <p className="mt-2 text-sm text-slate-600">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="section-padding">
        <div className="card mx-auto flex w-full max-w-6xl flex-col items-start justify-between gap-6 px-6 py-10 md:flex-row md:items-center md:px-10">
          <div>
            <h2 className="text-2xl font-semibold text-slate-900">
              {howItWorksData.cta.title}
            </h2>
            <p className="mt-2 text-sm text-slate-600">
              {howItWorksData.cta.subtitle}
            </p>
          </div>
          <button
            className="btn btn-primary"
            onClick={() =>
              logActivity("cta_click", { label: howItWorksData.cta.label })
            }
          >
            {howItWorksData.cta.label}
          </button>
        </div>
      </section>
    </div>
  );
}
